/**
 * Authentication API module
 */
import { authClient, apiRequest } from '../client.js';

export const authApi = {
  me: () =>
    apiRequest<{
      user: {
        id: string;
        discordId: string;
        username: string;
        displayName?: string;
        avatarUrl?: string;
        isGodMode: boolean;
        isAdmin: boolean;
      };
      guilds: Array<{
        id: string;
        name: string;
        isOwner: boolean;
      }>;
      sessionId: string;
    }>(authClient, {
      method: 'GET',
      url: '/me',
    }),

  refresh: () =>
    apiRequest<{
      user: {
        id: string;
        discordId: string;
        username: string;
        displayName?: string;
        avatarUrl?: string;
        isGodMode: boolean;
        isAdmin: boolean;
      };
      guilds: Array<{
        id: string;
        name: string;
        isOwner: boolean;
      }>;
    }>(authClient, {
      method: 'POST',
      url: '/refresh',
    }),

  logout: () =>
    apiRequest<{ success: boolean; message: string }>(authClient, {
      method: 'POST',
      url: '/logout',
    }),
};

export default authApi;
